// eslint-disable-next-line import/prefer-default-export
export function buildNestedGroupLabels(grupo) {
  if (!grupo) {
    return null;
  }
  const labels = [];
  let currentGroup = grupo;
  while (currentGroup) {
    labels.push(currentGroup.descricao);
    currentGroup = currentGroup.grupoPai;
  }
  return labels.join(' > ');
}
